//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//Componentes
import AvaliacaoResposta from '../../components/avaliacao/AvaliacaoResposta';
import VitalizePaper from '../VitalizePaper';
import LabelSecao from '../LabelSecao';
//Modelos
import AvaliacaoSecaoModel from '../../models/AvaliacaoSecao';
import AvaliacaoRespostaModel from '../../models/AvaliacaoResposta';

//Definindo estilos para o componente
const styles = (theme) => ({
    errorLabel: {
        color: theme.palette.error.main
    }
});

/**
 * Componente para renderizar uma seção da avaliação
 */
class AvaliacaoSecao extends Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleQuestaoChange = this.handleQuestaoChange.bind(this);
    }

    /**
     * Evento disparado quando há alteração nos dados de uma resposta
     * @param {AvaliacaoRespostaModel} questao Dados da questão atualizados
     */
    handleQuestaoChange(questao) {
        //Realiza uma cópia da seção
        const secao = AvaliacaoSecaoModel.clone(this.props.secao);
        //Atualiza os dados da questão
        secao.questoes[questao.ordem - 1] = AvaliacaoRespostaModel.clone(questao);
        //Dispara o evento de alteração
        if (this.props.onChange)
            this.props.onChange(secao);
    }

    render() {
        /** @type {AvaliacaoSecaoModel} */
        const secao = this.props.secao;
        const erros = this.props.erros;

        return (
            <Fragment>
                <VitalizePaper>
                    <Grid container spacing={1} >
                        <Grid item xs={12} >
                            <LabelSecao label={secao.titulo} />
                            <Typography className={this.props.classes.errorLabel} >{erros.erroSecao}</Typography>
                            <Typography className={this.props.classes.errorLabel} >{erros.erroRespostas}</Typography>
                        </Grid>
                    </Grid>
                </VitalizePaper>
                <VitalizePaper>
                    <Grid container spacing={4} >
                        {
                            secao.questoes.map((questao, indice) =>
                                <AvaliacaoResposta key={questao.id} questao={questao} erro={erros.respostas[indice]} onChange={this.handleQuestaoChange} />
                            )
                        }
                    </Grid>
                </VitalizePaper>
            </Fragment>
        );
    }
}

AvaliacaoSecao.propTypes = {
    /** Dados da seção da avaliação */
    secao: PropTypes.instanceOf(AvaliacaoSecaoModel),
    //Mensagens de erro da avaliação
    erros: PropTypes.shape({
        erroSecao: PropTypes.string,
        erroRespostas: PropTypes.string,
        respostas: PropTypes.array
    }),
    /** Evento disparado quando há uma alteração */
    onChange: PropTypes.func,
    /** Classes CSS para personalização do componente */
    classes: PropTypes.shape({
        errorLabel: PropTypes.string
    })
};

export default withStyles(styles)(AvaliacaoSecao);